



















































































import Vue from 'vue';
import Component from 'vue-class-component';
import router from '../router';
import { Route } from 'vue-router';
import addresses from '@/store/modules/addresses';
import controllers from '@/store/modules/controllers';
import store from '../store/store';

@Component
export default class CAppHeader extends Vue {
  private showProfileMenu: boolean = false;
  private items: Array<{ text: string, disabled: boolean, href: string }> = [];

  get useremail() {
    return this.$store.getters.user.email;
  }

  get username() {
    return this.$store.getters.user.name;
  }

  get loggedIn() {
    return this.$store.getters.loggedIn;
  }

  // get controllers() {
  //   return controllers.getControllers;
  // }

  private logout() {
    this.$store.commit('logout');
    router.push('/login');
  }

  private beforeMount() {
    router.afterEach((to, from) => {
      switch (to.name) {
        case 'login':
          this.items = [];
          return;
        case 'home':
          return this.enteredHome();
        case 'controllers':
          return this.enteredControllers(to);
        case 'controller':
          return this.enteredController(to);
        case 'addresses':
          return this.enteredAddresses(to);
        case 'events':
          return this.enteredEvents(to);
        case 'settings':
          return this.enteredSettings(to);
        case 'support':
          return this.enteredSupport(to);
        case 'statistics':
          return this.enteredStatistics(to);
        default:
          return this.enteredHome();
      }
    });

    return this.enteredHome();
  }

  private enteredHome() {
    this.items = [{text: 'Дом', href: '/', disabled: false}];
  }

  private enteredControllers(to: Route) {
    this.items = [
      {text: 'Дом', href: '/', disabled: false},
      {text: 'Контроллеры', href: to.fullPath, disabled: true},
    ];
  }

  private enteredController(to: Route) {
    const text: string = 'Контроллер';
    // let ctrls = this.controllers;
    // if (controllers.getControllers) {
    //   controllers.getControllers.forEach((el) => {
    //     if (el.id.toString() == to.params['id']) {
    //       text = `${el.serial}`;
    //     }
    //   });
    // }
    this.items = [
      {text: 'Дом', href: '/', disabled: false},
      {text: 'Контроллеры', href: '/controllers', disabled: false},
      {text, href: to.fullPath, disabled: true},
    ];
  }

  private enteredAddresses(to: Route) {
    this.items = [
      {text: 'Дом', href: '/', disabled: false},
      {text: 'Адреса', href: to.fullPath, disabled: true},
    ];
  }

  // private enteredAddress(to: Route) {
  //   let text: string = 'Адрес';
  //   if (addresses.addresses) {
  //     addresses.addresses.forEach((el) => {
  //       if (el.id.toString() == to.params['id']) {
  //         text = `${el.city}, ${el.street}, ${el.house}/${el.building}, ${el.flat}`;
  //       }
  //     });
  //   }
  //   this.items = [
  //     {text: 'Дом', href: '/', disabled: false},
  //     {text: 'Адреса', href: '/addresses', disabled: false},
  //     {text: 'Адрес', href: to.fullPath, disabled: true},
  //   ];
  // }

  private enteredEvents(to: Route) {
    this.items = [
      {text: 'Дом', href: '/', disabled: false},
      {text: 'События', href: to.fullPath, disabled: true},
    ];
  }

  private enteredSettings(to: Route) {
    this.items = [
      {text: 'Дом', href: '/', disabled: false},
      {text: 'Настройки', href: to.fullPath, disabled: true},
    ];
  }

  private enteredSupport(to: Route) {
    this.items = [
      {text: 'Дом', href: '/', disabled: false},
      {text: 'Поддержка', href: to.fullPath, disabled: true},
    ];
  }

  private enteredStatistics(to: Route) {
    this.items = [
      {text: 'Дом', href: '/', disabled: false},
      {text: 'Статистика', href: to.fullPath, disabled: true},
    ];
  }
}
